<template>
  <div name="demo-chart-radar">
    <radar-example></radar-example>
  </div>
</template>

<script>
import radarExample from './RadarExample'

export default {
  name: 'demo-chart-radar',
  components: {
    radarExample
  }
}
</script>


// WEBPACK FOOTER //
// demoChartRadar.vue?065ca7ef